<script setup>
import { onUpdated } from "vue"
import { useTreeStore } from '@/store/modules/trees.js';
import { Gems } from "@/gems"
import { KNOLIA } from "../knolia";
import { useDragAndDrop } from "../store/modules/drag-and-drop";
import { MESSAGES } from "../messages";

const store = useTreeStore()
const dragAndDrop = useDragAndDrop()

async function RemoveFromTree(elem) {
  Gems.Telegram(elem.children ? MESSAGES.QUESTIONS.REMOVE_SKILL_FROM_ACTIVITIES_TREE : MESSAGES.QUESTIONS.REMOVE_OP_SKILL_FROM_ACTIVITIES_TREE, 'tele-info', "", "tele-cancel")
    .then(
      async () => {
        const res = await KNOLIA.CallBackEnd("post", "remove-skill-from-task", {
          element: elem
        })

        if(res.error)
          Gems.Telegram(MESSAGES.ERROR.DEFAULT, 'tele-not-allowed')

        store.UpdateTasksTree()
      },
      () => {}
    )
}

onUpdated(() => {
  for (let element of store.SkillsArr) {
    // const sitemap = document.getElementById(`skill${element.skill_id}`)
    const deleteIcon = document.getElementById(`delete-skill${element.skill_id}`)
    
    // if (sitemap) 
    //   Gems.Tooltip(sitemap, element.sitemap, "tooltip")
  
    if(deleteIcon && element.included)
      Gems.Tooltip(deleteIcon, "Dissociar Competência", "tooltip")

    const skillElem = document.getElementById(`skill${element.skill_id}`)
    if(skillElem) {
      dragAndDrop.setDragFunctionElem(function () {
        element.fromSkillsList = true
        dragAndDrop.setDraggedData({element: element})
      }, skillElem)
    }

    for (let child of element.children) {
      const childSitemap = document.getElementById(`skill-op${child.id}`)
      const deleteIcon = document.getElementById(`delete-skill-op${child.id}`)

      if (childSitemap) 
        Gems.Tooltip(childSitemap, child.sitemap == null ? 'Não atribuído' : child.sitemap, "tooltip tooltip-left")

      if(deleteIcon && element.included)
        Gems.Tooltip(deleteIcon, "Remover da árvore", "tooltip")

      const OpSkillElem = document.getElementById(`op-skill${child.id}`)
      if(OpSkillElem) {
        dragAndDrop.setDragFunctionElem(function () {
          child.fromSkillsOpList = true
          dragAndDrop.setDraggedData({element: child})
        }, OpSkillElem)
      }
    }
  }
});
</script>

<template>
  <section class="skill-list-section ">
    <div class="skill-container">
      <div>
        <div class="div-skills-header">
          <span>Competências</span>
        </div>

        <div class="div-skills-list" v-for="(elem, i) in store.SkillsArr" :style="elem.visible" :key="i">

          <div draggable="true" :id="`skill${elem.skill_id}`" class="skill default-radius bg-alt-line">
            <div class="d-flex align-items-center skill-line">
              <div class="div-remove-icon">
                <i class="fa fa-share fa-flip-horizontal cursor-pointer" :id="`delete-skill${elem.skill_id}`" v-if="elem.included" @click="RemoveFromTree(elem)"
                  @mouseenter="Gems.Tooltip($event.target, 'Remover os filhos da árvore', 'tooltip')"></i>
              </div>
              
              <span :id="`skill${elem.skill_id}`" class="line-clamp line-clamp-1">
                {{ elem.designation }}
              </span>
            </div>

            <i class="fa cursor-pointer show-childs" :class="{'fa-chevron-down': !elem.showChildren , 'fa-chevron-up': elem.showChildren}"
              @click="elem.showChildren = !elem.showChildren"></i>
          </div>
          
          <div class="div-line-skills-op-list" v-show="elem.showChildren">
            <div v-for="(child, idx) in elem.children" :key="idx" draggable="true" :id="`op-skill${child.id}`" class="d-flex align-items-center">
              <i class="fa fa-share fa-flip-horizontal remove-icon cursor-pointer" :id="`delete-skill-op${child.id}`" v-if="child.included" @click="RemoveFromTree(child)"
                @mouseenter="Gems.Tooltip($event.target, 'Remover elemento da árvore', 'tooltip')"></i>
              
              <span :id="`skill-op${child.id}`" class="line-clamp line-clamp-1">
                {{ child.designation }}
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<style scoped>

.skill-list-section {
  text-align: center;
  /* max-width: max-content;
  min-width: 500px; */
}


.div-skills-header {
  display: flex;
}

.div-skills-header span {
  flex: 1;
  font-weight: bold;
}

.div-line-skills-op-list {
  padding-left: 30px;
}

.div-line-skills-op-list div {
  margin-bottom: 8px;
  gap: 10px;
}

.div-skills-list div {
  text-align: start;
}

.skill-line {
  gap: 10px;
}

.div-remove-icon {
  font-size: 0.8em;
  width: 11px;
  display: inline-block;
}

.skill {
  padding-top: 5px;
  padding-bottom: 5px;
  margin-bottom: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: grab;
}

.show-childs {
  height: 10px;
}
</style>
